module.exports = __webpack_public_path__ + "img/25_27.6522024f.png";